export enum BrxmCtypeEnum {
  BANNER = 'Banner',
  FEATURED_CONTENT = 'FeaturedContent',
  CARD = 'Card',
  TILE_GRID = 'TileGrid',
  PAGE_META_DATA = 'PageMetadata',
  UTILITY_MENU = 'UtilityMenu',
  HORIZONTAL_HEADER = 'HorizontalHeader',
  HEADER_NAVIGATION = 'HeaderNavigation',
  FOOTER_MENU = 'FooterMenu',
  TEXT = 'Text',
  PDF_LISTING = 'PdfListing',
  RICH_CONTENT = 'RichContent',
  TEXT_WITH_CTA = 'TextWithCTA',
  BROCHURE = 'Brochure',
  PRODUCT_PIXEL = 'ProductPixel',
  TABBED_CONTENT = 'TabbedContent',
  DOCUMENT_LIST = 'DocumentListColumns',
  TAB_ICONS = 'TabIcons',
  FEATURE_ICONS_CAROUSEL = 'FeatureIconsCarousel',

  // Static components
  PRODUCT_LISTING = 'ProductListing',
  PDP_DETAILS = 'PDPDetails',
  MY_ACCOUNT = 'MyAccount',
  CHECKOUT = 'Checkout',
  FIND_A_RETAILER = 'FindARetailer',
  COMPARE_PRODUCTS = 'CompareProducts',
  CART = 'Cart',
  ORDER_CONFIRMATION = 'OrderConfirmation',
  CATALOG_BUILDER = 'CatalogBuilder',
  ROOMVO_VISUALIZER = 'RoomvoVisualizer'
}
